import React from 'react';

export default ({report}) => (
  <React.Fragment>
    GOA: <strong>{report.locationGOA || 'Not Provided'}</strong><br />
    Location: <strong>{report.location || 'Not Provided'}</strong><br />
    Location Address: <strong>{report.locationAddress || 'Not Provided'}</strong><br />
    Location Phone: <strong>{report.locationPhone || 'Not Provided'}</strong><br />
  </React.Fragment>
);


// WEBPACK FOOTER //
// ./src/views/report/report-header-location.js